import { render } from "./NotificationModal.vue?vue&type=template&id=48cc72e1&scoped=true&ts=true"
import script from "./NotificationModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationModal.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationModal.vue?vue&type=style&index=0&id=48cc72e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cc72e1"],['__file',"src/pages/notificationmodal/NotificationModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48cc72e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48cc72e1', __exports__)) {
    api.reload('48cc72e1', __exports__)
  }
  
  module.hot.accept("./NotificationModal.vue?vue&type=template&id=48cc72e1&scoped=true&ts=true", () => {
    api.rerender('48cc72e1', render)
  })

}


export default __exports__